import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { UnredirectedRoutesService } from '@aid/core/services';
import { OrganizationService } from '@aid/core/services/organization.service';

@Injectable({
  providedIn: 'root'
})
export class NotFoundInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private unredirectedRoutesService: UnredirectedRoutesService,
    private organizationService: OrganizationService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        const notFoundRegistered = this.unredirectedRoutesService.isUrlRegistered(
          req.url
        );

        if (notFoundRegistered) {
          return of(error);
        }
        // A failed save must remain on its form so the owner can show the
        // recovery message and keep the entered values available for retry.
        if (
          error instanceof HttpErrorResponse &&
          error.status === 404 &&
          req.method === 'GET'
        ) {
          this.router.navigate([
            this.organizationService.requireOrganization().slug,
            'not-found'
          ]);
        }
        return of(error);
      })
    );
  }
}
